var modules_72a695e8 = {"container":"_1ialcz0","content":"_fw4nb4","query":"_hnjqki","queryText":"_1habg4e","msgItemList":"_1d3pa0y","msgMenuItem":"_unkhyk","footer":"_5gxzrp","menu":"_ncyyxn","menuAction":"_1qs7951","message":"_zwhhrc","messageText":"_mr70dt","crossIcon":"_khtw3c","arrowIcon":"_8urf3r"};
import "../../../assets/DlqFDHoi.css";

export { modules_72a695e8 as default };
//# sourceMappingURL=Scenario.module.less.js.map
